import { Toaster } from '@/shared/components/Toaster.tsx';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { AuthGuard } from '@/routes/AuthGuard.tsx';
import { AuthCallback } from '@/routes/AuthCallback.tsx';
import { LoginCallback } from '@okta/okta-react';
import { FullscreenLoadingSpinner } from '@/shared/components/FullscreenLoadingSpinner.tsx';
import { environment } from '@/environment.ts';
import { SelectedMarketRouteWrapper } from '@/modules/supplierProductManagement/SelectedMarketRouteWrapper.tsx';
import { SupplierManagementPage } from '@/modules/supplierProductManagement/SupplierManagementPage.tsx';
import { OrderRoute } from '@/routes/OrderRoute.tsx';
import { FulfillmentRoute } from '@/routes/FulfillmentRoute.tsx';
import { DirectFulfillmentRoute } from '@/routes/DirectFulfillmentRoute.tsx';
import { PositionRoute } from '@/routes/PositionRoute.tsx';
import { SalesforceDealImporterRoute } from '@/routes/SalesforceDealImporterRoute.tsx';
import { OrderConfirmationRoute } from '@/routes/OrderConfirmationRoute.tsx';
import { BulkPositionCreatorRoute } from '@/routes/BulkPositionCreatorRoute.tsx';

// NOTE: The layout routes below ensure that the correct context is defined for the route.
// See: https://reactrouter.com/en/main/route/route#layout-routes
export function App() {
    const location = useLocation();
    return (
        <>
            <Routes>
                <Route path="/" element={<AuthGuard />}>
                    <Route path="" element={<Navigate to={`order${location.search}`} />} />

                    <Route path="order" element={<OrderRoute />} />
                    <Route path="order/:orderId" element={<OrderRoute />} />
                    <Route path="position/:positionId/order" element={<OrderRoute />} />
                    <Route path="order/:orderId/fulfillment" element={<FulfillmentRoute />} />
                    <Route path="order/:orderId/confirmation" element={<OrderConfirmationRoute />} />
                    <Route path="position/:positionId/fulfillment" element={<DirectFulfillmentRoute />} />
                    <Route path="position" element={<PositionRoute />} />
                    <Route path="position/:positionId" element={<PositionRoute />} />
                    <Route path="import/deal/:opportunityId" element={<SalesforceDealImporterRoute />} />
                    <Route path="tools/bulk-position-creator" element={<BulkPositionCreatorRoute />} />

                    <Route element={<SelectedMarketRouteWrapper />}>
                        <Route path="supply-management/products" element={<SupplierManagementPage />} />
                    </Route>
                </Route>
                {environment.AUTH_PROVIDER === 'oauth' ? (
                    <Route path="/auth/callback" element={<AuthCallback />} />
                ) : (
                    <Route
                        path="/login/callback"
                        element={<LoginCallback loadingElement={<FullscreenLoadingSpinner />} />}
                    />
                )}
            </Routes>
            <Toaster />
        </>
    );
}
